<template>
  <div class="search-wrap">
    <div class="search-wrap__filter">
      <div :class="[userTheme ? `text-${userTheme}` : '']" class="search-wrap__filter__filterText" @click="toggleSearchWrap">
        <i class="iconfont icon-filter"></i>
        <template v-if="!$slots.head">
          展開/收合
        </template>
        <slot name="header"></slot>
      </div>
    </div>

    <transition name="collapseTransition">
      <div class="search-wrap__container" v-show="!searchHead">
        <div class="search-wrap__container__searchBar" :class="row ? '' : 'search-column'">
          <slot name="container"></slot>
        </div>
      </div>
    </transition>
    <div class="search-wrap__handler">
      <slot name="handler"></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'ToggleSearchWrap',
  description: '摺疊搜尋列',
  props: {
    row: {
      type: [Boolean],
      default() {
        return true;
      },
    },
  },
  data() {
    return {
      searchHead: false,
    };
  },
  methods: {
    toggleSearchWrap() {
      this.searchHead = !this.searchHead;
    },
  },
  watch: {
    '$vuetify.breakpoint.width': {
      handler() {
        if (this.$vuetify.breakpoint.width > 768) {
          this.searchHead = false;
        }
      },
    },
  },
  computed: {
    ...mapGetters('userInfo', ['userStyle']),
    ...mapState('userInfo', ['userInfo']),
    userTheme() {
      let theme = '';
      if (this.userInfo.userStyle) {
        theme = this.userInfo.userStyle;
      }
      return theme;
    },
  },
};
</script>

<style lang="scss" scoped>
.search-wrap {
  margin-bottom: 24px;

  @include pad-width() {
    display: flex;
    margin-bottom: 12px;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 28px;
  }

  &__filter {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 0.5rem;
    @include pad-width() {
      display: none;
    }

    @include pad-width() {
      justify-content: space-between;
    }

    &__filterText {
      color: $primaryColor1;
      cursor: pointer;
      padding: 4px 8px;
      border-radius: 8px;
      background: #f2f2f2;

      i {
        margin-right: 8px;
      }
    }
  }

  &__container {
    overflow: hidden;

    &__searchBar {
      padding: 12px 8px;
      background: #f2f2f2;
      border-radius: 8px;
      margin-bottom: 1rem;

      @include pad-width() {
        display: flex;
        align-items: flex-end;
        flex-wrap: wrap;
        background: none;
        padding: 0;
        margin-bottom: 0;
      }

      @include pc-width() {
        background: none;
      }

      ::v-deep > div {
        width: 100%;
        margin-bottom: 0.5rem;

        @include pad-width() {
          margin-bottom: 0;
          margin-right: 1rem;
          width: 300px;
          text-overflow: ellipsis;

          .v-input {
            height: 70px;
          }
        }

        @include pc-width() {
          width: 300px;

        }
      }
      ::v-deep .date-picker {
        @include pad-width{
          width: 100%;
          max-width: 288px;
        }
      }

      ::v-deep > button {
        width: 100%;
        margin-right: 0.5rem;
        @include pad-width() {
          margin-bottom: 2.375rem;
          width: initial;
          margin-top: 32px;
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
  &__handler {
    text-align: right;
    white-space: nowrap;

    ::v-deep > button {
      margin-left: 0.5rem;
      @include pad-width() {
        margin-bottom: 0rem;
        margin-bottom: 0.5rem;
        width: initial;
      }
    }
  }
}

.search-column {
  display: flex !important;
  flex-direction: column;
  align-items: center;
  ::v-deep .v-input--selection-controls {
    height: inherit !important;
  }
}

</style>>
